import React from 'react'
import { FileInput, Lock, Smartphone, TabletSmartphone } from 'lucide-react';

export default function () {
	const etapas = [
		{
			icon: <Lock size={28} />,
			title: "Segurança dos dados sensíveis e controle dos acessos",
			description: "Suas informações médicas totalmente protegidas e acessíveis somente a pessoas autorizadas.",
			number: 1
		},
		{
			icon: <Smartphone size={28} />,
			title: "Acesso completo por Web e não consome memória no celular",
			description: "Não ha necessidade de instalar nenhum aplicativo, tudo funciona na Web.",
			number: 2
		},
		{
			icon: <FileInput size={28} />,
			title: "Disponibilidade dos dados de urgência",
			description: "Seus dados disponíveis em situações de urgência.",
			number: 3
		},
		{
			icon: <TabletSmartphone size={28} />,
			title: "Acesso dos dados de urgência na primeira tela do celular",
			description: "Acesso facilitado logo na primeira tela do seu celular.",
			number: 4
		}
	];

	return (
		<section id="funcionamento" className="pb-20 pt-28 px-4 bg-white">
			<div className="container mx-auto">
				<div className="text-center mb-16">
					<h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
						Características
					</h2>
					<p className="text-lg text-gray-700 max-w-3xl mx-auto">
						Uma solução simples e eficaz para ter seus dados médicos sempre ao alcance.
					</p>
				</div>

				<div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">
					{etapas.map((etapa, index) => (
						<Etapa
							key={index}
							icon={etapa.icon}
							title={etapa.title}
							description={etapa.description}
							number={etapa.number}
						/>
					))}
				</div>
			</div>
		</section>
	)
}

function Etapa({ icon, title, description, number }) {
	return (
		<div className="flex flex-col md:flex-row items-center md:items-start gap-6">
			<div className="flex-shrink-0 w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center text-white">
				{icon}
			</div>

			<div className="flex-1 text-center md:text-left">
				{/* <div className="text-sm font-medium text-gray-600 mb-1">Etapa {number}</div> */}
				<h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
				<p className="text-gray-700">{description}</p>
			</div>
		</div>
	)
}